import { createContext, useState } from 'react';

import { getComepnsationReasons } from 'services/compensation';
import { checkOrderExistance } from 'services/hubs';
import { getBusiness } from 'services/business';

import { notify } from 'components/Notify/Notify';

export const CompensationFormContext = createContext({});

export const FormContextWrapperProvider = ({ children }) => {
  const [isInsured, setIsInsured] = useState(false);
  const [selectedReason, setSelectedReason] = useState(null);
  const [compesationReasons, setCompensationReasons] = useState([]);
  const [selectedDeliveries, setSelectedDeliveries] = useState([]);
  const [isImmediateSubmission, setIsImmediateSubmission] = useState(false);
  const [businessDetails, setBusinessDetails] = useState({});
  const [deparments, setDepartments] = useState([]);

  const [updateSum, setUpdateSum] = useState(0);

  const getCompensationInfo = async (delivery) => {
    try {
      const { data: compensationReasons } = await getComepnsationReasons();
      setCompensationReasons(compensationReasons);

      const deliveryDetails = await checkOrderExistance({
        ids: delivery.trackingNumber || delivery.order_id
      });

      setSelectedDeliveries(deliveryDetails);
    } catch (error) {
      notify(error.message);
    }
  };

  const getBusinessDetails = async (businessId) => {
    try {
      const data = await getBusiness(businessId);
      setBusinessDetails(data);
    } catch (error) {
      notify(error.message);
    }
  };

  return (
    <CompensationFormContext.Provider
      value={{
        isInsured,
        setIsInsured,
        selectedReason, // selected reason full Object
        setSelectedReason,
        compesationReasons, //full array of reasons from BE
        selectedDeliveries,
        setSelectedDeliveries,
        getCompensationInfo, // fetch all reasons & validates delivery existance
        isImmediateSubmission,
        setIsImmediateSubmission,
        businessDetails,
        setBusinessDetails,
        deparments, // array of full department objects filtered by reason
        setDepartments,
        getBusinessDetails,
        updateSum,
        setUpdateSum
      }}
    >
      {children}
    </CompensationFormContext.Provider>
  );
};
